export default __webpack_public_path__ + "static/media/photo--lg--group.abc6abf5.jpg";